// Columns of the LP Pipeline (fundraising) table on the entity Fundraise Dashboard.
//
// `sortKey` must match a key of SalesforceFundraisingsService::SORTABLE_FIELDS in
// alps-be, which maps it to the SOQL field, or be `health`, which the API ranks
// itself since health is not a Salesforce field. Sorting is server-side because the
// table is paginated, so a column without a `sortKey` (Action) is not sortable.
// `field` is the record key the column reads, and doubles as the DataGrid column
// id. `type` drives the cell renderer in fundraisingGridColumns.
export const FUNDRAISING_COLUMNS = [
	{
		label: 'Account',
		sortKey: 'account_name',
		field: 'account_name',
		type: 'account',
		minWidth: 170,
	},
	{
		label: 'Investor Type',
		sortKey: 'investor_type',
		field: 'investor_type',
		minWidth: 130,
	},
	{
		label: 'Internal Coverage',
		sortKey: 'internal_coverage',
		field: 'internal_coverage',
		minWidth: 150,
	},
	{
		label: 'Health',
		sortKey: 'health',
		field: 'health',
		type: 'health',
		align: 'center',
		minWidth: 90,
	},
	{
		label: 'Active',
		sortKey: 'active',
		field: 'active',
		type: 'boolean',
		minWidth: 90,
	},
	{
		label: 'Existing Investor',
		sortKey: 'existing_investor',
		field: 'existing_investor',
		type: 'boolean',
		minWidth: 150,
	},
	{
		label: 'Commitment',
		sortKey: 'commitment',
		field: 'commitment',
		type: 'currency',
		minWidth: 130,
	},
	{
		label: 'Stage',
		sortKey: 'stage',
		field: 'stage',
		type: 'stage',
		minWidth: 150,
	},
	{
		label: 'Anticipated Close Date',
		sortKey: 'anticipated_close_date',
		field: 'anticipated_close_date',
		type: 'date',
		minWidth: 190,
	},
	{
		label: 'Closing Round',
		sortKey: 'closing_round',
		field: 'closing_round',
		minWidth: 140,
	},
	{
		label: 'Last Interaction Date',
		sortKey: 'last_interaction_date',
		field: 'last_interaction_date',
		type: 'date',
		minWidth: 180,
	},
	{ label: 'Action', sortKey: null, field: 'actions', type: 'actions', minWidth: 80 },
];

export const FUNDRAISING_SORT_KEYS = FUNDRAISING_COLUMNS.filter(
	({ sortKey }) => sortKey
).map(({ sortKey }) => sortKey);

// The same fundraising table scoped to a single LP on the LP360 page (CR-6553):
// the Account column is replaced by the fund the record is raising for, and the
// investor profile columns are dropped since they are constant within one LP.
export const LP_FUNDRAISING_COLUMNS = [
	{
		label: 'Entity',
		sortKey: 'entity_name',
		field: 'entity_name',
		minWidth: 170,
	},
	{
		label: 'Active',
		sortKey: 'active',
		field: 'active',
		type: 'boolean',
		minWidth: 90,
	},
	{
		label: 'Existing Investor',
		sortKey: 'existing_investor',
		field: 'existing_investor',
		type: 'boolean',
		minWidth: 130,
	},
	{
		label: 'Commitment',
		sortKey: 'commitment',
		field: 'commitment',
		type: 'currency',
		minWidth: 130,
	},
	{
		label: 'Stage',
		sortKey: 'stage',
		field: 'stage',
		type: 'stage',
		minWidth: 150,
	},
	{
		label: 'Anticipated Close Date',
		sortKey: 'anticipated_close_date',
		field: 'anticipated_close_date',
		type: 'date',
		minWidth: 160,
	},
	{
		label: 'Closing Round',
		sortKey: 'closing_round',
		field: 'closing_round',
		minWidth: 140,
	},
	{
		label: 'Last Interaction Date',
		sortKey: 'last_interaction_date',
		field: 'last_interaction_date',
		type: 'date',
		minWidth: 180,
	},
	{ label: 'Action', sortKey: null, field: 'actions', type: 'actions', minWidth: 80 },
];

export const LP_FUNDRAISING_SORT_KEYS = LP_FUNDRAISING_COLUMNS.filter(
	({ sortKey }) => sortKey
).map(({ sortKey }) => sortKey);
